// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "styles/" + {"216":"vendors","532":"styles"}[chunkId] + "." + {"216":"ebe64191dd3bd7a1db21","532":"f24aa18195245c775956"}[chunkId] + ".css";
};